<template>
  <div class="showDetail" ref="showDetail" :style="detailStyle" v-if="toShowDetail" v-loading="loading" @mousedown="moveDown">
    <div @mousedown.stop="">
      <div class="showDetail-header">
        <div class="showDetail-header-left">
          <el-tabs v-model="current" @tab-click="handleClick" v-if="ids.length > 1">
            <el-tab-pane v-for="(name, index) in ids" :key="index" :label="name.Name" :name="name.Id"></el-tab-pane>
          </el-tabs>
          <div class="showDetail-title" v-else>{{detail.Name}}</div>
        </div>
        <i class="el-icon-close" @click.stop="close"></i>
      </div>
      <template v-if="toShowDetail.labels === 'Person'">
        <div class="showDetail-row">{{ $i18n.$t('人物别名：') }}{{ (toShowDetail.Alias || []).join(',') }}</div>
        <div class="showDetail-row-title">{{ $i18n.$t('基本信息') }}</div>
        <div class="showDetail-row-flex">
          <div class="showDetail-row-flex-item">{{ $i18n.$t('性别：') }}
              <span v-if="toShowDetail.Gender === '1'">{{ $i18n.$t('男') }}</span>
              <span v-else-if="toShowDetail.Gender === '2'">{{ $i18n.$t('女') }}</span>
              <span v-else>{{ $i18n.$t('未知') }}</span>
          </div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('朝代：') }}{{ toShowDetail.Dynasty }}</div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('分类：') }}{{ toShowDetail.Category }}</div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('宗派：') }}{{ toShowDetail.Sect }}</div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('出生时间：') }}{{ toShowDetail.Birthday }}</div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('逝世时间：') }}{{ toShowDetail.Deathday }}</div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('籍贯：') }}{{ (toShowDetail.native_place || []).join(',') }}</div>
          <div class="showDetail-row-flex-item">{{ $i18n.$t('驻锡地：') }}{{ (toShowDetail.work_place || []).join(',') }}</div>
        </div>
        <div class="showDetail-row-title">{{ $i18n.$t('简介') }}</div>
        <div class="showDetail-row">{{ toShowDetail.Introduction }}</div>
        <div class="showDetail-row-tab">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="row.name" :name="row.name" v-for="(row, index) in tabList" :key="index">
              <div class="showDetail-row" style="margin-top: 0;" v-html="(Object.prototype.toString.call(toShowDetail[row.key]) === '[object Array]' ? (toShowDetail[row.key] || []).join('<br />') : toShowDetail[row.key])?.replace(/\n/g, '<br />')"></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
      <template v-if="toShowDetail.labels === 'Address'">
        <div class="showDetail-row">{{ $i18n.$t('别称：') }}{{ (toShowDetail.Alias || []).join(',') }}</div>
        <div class="showDetail-row">{{ $i18n.$t('类别：') }}{{ toShowDetail.labels }}</div>
        <!-- <div class="showDetail-row">行政区：中国-河北-保定市-涿州县</div> -->
        <div class="showDetail-row">{{ $i18n.$t('经纬度：') }}{{ toShowDetail.Longitude }},{{ toShowDetail.Latitude }}</div>
        <!-- <div class="showDetail-row">朝代：唐</div>
        <div class="showDetail-row">属地：河北道</div>
        <div class="showDetail-row">备注：（618 ~ 907）縣級行政中心所在地</div> -->
        <div class="showDetail-row">{{ $i18n.$t('注解：') }}{{ toShowDetail.Introduction }}</div>
      </template>
      <template v-if="toShowDetail.labels === 'RecordedIn'">
        <div class="showDetail-row" v-if="toShowDetail.PersonName">{{ $i18n.$t('人物名称：') }}{{ toShowDetail.PersonName }}</div>
        <div class="showDetail-row">{{ $i18n.$t('分类：') }}{{ toShowDetail.Category }}</div>
        <div class="showDetail-row">{{ $i18n.$t('目录：') }}{{ toShowDetail.Catalog }}</div>
        <div class="showDetail-row">{{ $i18n.$t('原文：') }}<span v-html="toShowDetail.OriginalText?.replace(/\n/g, '<br />')"></span></div>
        <div class="showDetail-row">{{ $i18n.$t('译文：') }}<span v-html="toShowDetail.VernacularText?.replace(/\n/g, '<br />')"></span></div>
      </template>
    </div>
  </div>
</template>
<script>
import { personDetail, getRecordedIn } from '@/api/home'
import { addressDetail } from '@/api/place'
import { biographieDetail } from '@/api/biographie'
import { i18n } from '@/i18n'
export default {
  name: 'visShowDetail',
  props: {
    detail: {
      type: Object,
      default: null
    },
    ids: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    detail (val) {
      if (val) {
        if (this.ids[0]) {
          this.current = this.ids[0].Id
        }
        this.getDetail()
      }
    }
  },
  computed: {
    toShowDetail () {
      return this.reqDetail || this.detail
    }
  },
  data () {
    return {
      activeName: i18n.$t('扩展介绍'),
      tabList: [
        { name: i18n.$t('扩展介绍'), key: 'ExtendedIntroduction' },
        { name: i18n.$t('记载于'), key: 'RecordedInfo' },
        // { name: '著作列表', key: 'Works' },
        // { name: '研究文献', key: 'ResearchLiterature' },
        { name: i18n.$t('原文'), key: 'OriginalText' },
        { name: i18n.$t('白话文'), key: 'VernacularText' }
      ],
      loading: false,
      reqDetail: null,
      current: '',
      detailStyle: {
        position: '',
        left: '',
        top: ''
      },
      detailPosition: {
        pageX: 0,
        pageY: 0,
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    move (e) {
      const { pageX, pageY } = e
      this.detailStyle = {
        position: 'fixed',
        left: `${pageX - this.detailPosition.x}px`,
        top: `${pageY - this.detailPosition.y}px`
      }
    },
    moveDown (e) {
      const { pageX, pageY } = e
      const { left, top } = this.$refs.showDetail.getBoundingClientRect()
      this.detailPosition = {
        pageX,
        pageY,
        x: pageX - left,
        y: pageY - top
      }
      this.detailStyle = {
        position: 'fixed',
        left: `${left}px`,
        top: `${top}px`
      }
      window.addEventListener('mousemove', this.move)
      window.addEventListener('mouseup', this.moveUp)
    },
    moveUp (e) {
      window.removeEventListener('mousemove', this.move)
      window.removeEventListener('mouseup', this.moveUp)
    },
    handleClick (row) {
      // if (this.current === row.name) return false
      // this.current = row.name
      this.$emit('tab-change', row.name)
      this.loading = true
      if (this.detail.labels === 'Address') {
        addressDetail({
          Id: row.name
        }).then(res => {
          this.reqDetail = res.data
        }).finally(() => {
          this.loading = false
        })
        return false
      }
      getRecordedIn({
        id: row.name
      }).then(res => {
        if (res.data.data.Id) {
          // recordedInDetail({
          //   Id: res.data.data.Id
          // }).then(res => {
          //   this.reqDetail = res.data
          // }).finally(() => {
          //   this.loading = false
          // })
          this.reqDetail = res.data.data
          this.loading = false
        } else {
          this.reqDetail = {}
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    close () {
      this.reqDetail = null
      this.$emit('close')
    },
    getDetail () {
      let Method = null
      switch (this.detail.labels) {
        case 'Person':
          Method = personDetail
          break
        case 'Address':
          Method = addressDetail
          break
        case 'Biographie':
          Method = biographieDetail
          break
        case 'RecordedIn':
          // Method = recordedInDetail
          break
      }
      if (Method) {
        this.loading = true
        this.reqDetail = null
        Method({
          Id: this.detail.Id
        }).then(res => {
          this.reqDetail = res.data
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-tabs__item {
  font-size: 20px;
}
.showDetail {
  position: absolute;
  right: 30px;
  top: 30px;
  background-color: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  width: 600px;
  max-height: 640px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.10);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9999;
  &-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      width: calc(100% - 40px);
    }
    i {
      font-size: 24px;
      font-weight: 700;
      text-align: left;
      color: #333333;
      cursor: pointer;
    }
  }
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 26px;
    font-weight: 700;
    text-align: left;
    color: #333333;
  }
  &-row {
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    color: #333333;
    margin-top: 20px;
    &-title {
      font-size: 20px;
      font-weight: 500;
      text-align: left;
      color: #987443;
      padding-left: 8px;
      box-sizing: border-box;
      position: relative;
      margin-top: 20px;
      &::before {
        content: "";
        width: 2px;
        height: 16px;
        background: #987443;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -8px;
      }
    }
    &-flex {
      display: flex;
      flex-wrap: wrap;
      &-item {
        font-size: 18px;
        font-weight: 400;
        text-align: left;
        color: #333333;
        padding-right: 30px;
        border-right: 1px solid #e2dacf;
        margin-right: 30px;
        box-sizing: border-box;
        margin-top: 20px;
        &:last-child {
          border-right: none;
          margin-right: 0;
          padding-right: 0;
        }
      }
    }
    &-tab {
      margin-top: 20px;
    }
  }
}
</style>
